/* TDLS Sections — Scroll animation observer + tab/accordion logic */
(function () {
  /* ---------- Intersection Observer for .tdls-fade-in ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    function observe() {
      document.querySelectorAll('.tdls-fade-in:not(.visible)').forEach(function (el) {
        io.observe(el);
      });
    }

    observe();
    /* Re-observe when new sections load via Shopify editor */
    document.addEventListener('shopify:section:load', observe);
  } else {
    /* Fallback: show everything */
    document.querySelectorAll('.tdls-fade-in').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  /* ---------- Scroll-triggered effects for touch / non-mouse devices ---------- */
  if ('IntersectionObserver' in window) {
    var isTouch = !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (isTouch && !reducedMotion) {
      var touchCards = document.querySelectorAll(
        '.page-timeline-content, .info-card, .cta-slide, .shop-cat-card'
      );
      var touchObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('in-view', entry.isIntersecting);
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -20% 0px' });
      touchCards.forEach(function (el) { touchObs.observe(el); });
    }

    /* Timeline dot activation (all devices) */
    var timelineDots = document.querySelectorAll('.page-timeline-dot');
    if (timelineDots.length) {
      var dotObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var step = entry.target.closest('.page-timeline-step');
            if (step) step.classList.add('in-view');
          }
        });
      }, { threshold: 0.5 });
      timelineDots.forEach(function (dot) { dotObs.observe(dot); });
    }

    /* Timeline line fill on scroll */
    var timelineFill = document.querySelector('.page-timeline-fill');
    var timelineLine = document.querySelector('.page-timeline-line');
    if (timelineFill && timelineLine) {
      function updateTimelineFill() {
        var rect = timelineLine.getBoundingClientRect();
        var viewMid = window.innerHeight * 0.65;
        var progress = Math.min(Math.max((viewMid - rect.top) / rect.height, 0), 1);
        timelineFill.style.height = (progress * 100) + '%';
      }
      window.addEventListener('scroll', updateTimelineFill, { passive: true });
      updateTimelineFill();
    }
  }

  /* ---------- Process tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.tdls-process__tab');
    if (!tab) return;
    var section = tab.closest('.tdls-process');
    if (!section) return;
    var target = tab.getAttribute('data-tab');

    section.querySelectorAll('.tdls-process__tab').forEach(function (t) {
      t.classList.toggle('active', t === tab);
    });
    section.querySelectorAll('.tdls-process__panel').forEach(function (p) {
      p.classList.toggle('active', p.getAttribute('data-panel') === target);
    });
  });

  /* ---------- Feature-split media slider ---------- */
  function initFeatureSplitSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (slider) {
      if (slider.__fssInit) return;
      slider.__fssInit = true;

      var slides = slider.querySelectorAll('.feature-split-slider__slide');
      if (slides.length < 2) {
        slider.querySelector('.feature-split-slider__dots').style.display = 'none';
        return;
      }

      var dotsWrap = slider.querySelector('.feature-split-slider__dots');
      var current = 0;
      var autoInterval = null;
      var intervalMs = parseInt(slider.getAttribute('data-interval'), 10) || 5000;

      // Build dots
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'feature-split-slider__dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); resetAuto(); });
        dotsWrap.appendChild(dot);
      });
      var dots = dotsWrap.querySelectorAll('.feature-split-slider__dot');

      function goTo(idx) {
        slides[current].classList.remove('active');
        pauseVideo(slides[current]);
        dots[current].classList.remove('active');
        current = idx;
        slides[current].classList.add('active');
        playVideo(slides[current]);
        dots[current].classList.add('active');
      }

      function next() { goTo((current + 1) % slides.length); }

      function pauseVideo(slide) {
        var v = slide.querySelector('video');
        if (v) { v.pause(); v.removeAttribute('autoplay'); }
      }
      function playVideo(slide) {
        var v = slide.querySelector('video');
        if (v) { v.setAttribute('autoplay', ''); v.play().catch(function(){}); }
      }

      function resetAuto() {
        clearInterval(autoInterval);
        autoInterval = setInterval(next, intervalMs);
      }

      // Swipe support
      var startX = 0;
      slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) goTo((current + 1) % slides.length);
        else goTo((current - 1 + slides.length) % slides.length);
        resetAuto();
      }, { passive: true });

      // Prevent hover/focus from pausing auto-advance
      slider.addEventListener('mouseenter', function () { resetAuto(); });
      slider.addEventListener('mouseleave', function () { resetAuto(); });

      // Prevent video clicks from stopping the slider
      slider.querySelectorAll('video').forEach(function (v) {
        v.style.pointerEvents = 'none';
      });

      resetAuto();
    });
  }

  initFeatureSplitSliders();
  document.addEventListener('shopify:section:load', initFeatureSplitSliders);

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var question = e.target.closest('.tdls-faq__question');
    if (!question) return;
    var item = question.closest('.tdls-faq__item');
    if (!item) return;

    var isOpen = item.classList.contains('active');
    /* Close siblings */
    item.parentElement.querySelectorAll('.tdls-faq__item.active').forEach(function (i) {
      i.classList.remove('active');
    });
    if (!isOpen) item.classList.add('active');
  });

  /* ---------- Stats count-up ---------- */
  function animateCountUp(el) {
    var target = parseInt(el.getAttribute('data-target'), 10);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 2000;
    var start = 0;
    var startTime = null;

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var value = Math.floor(progress * target);
      el.textContent = prefix + value + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var statsIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll('[data-target]').forEach(animateCountUp);
          statsIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.tdls-stats').forEach(function (el) {
      statsIo.observe(el);
    });

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.tdls-stats').forEach(function (el) {
        statsIo.observe(el);
      });
    });
  }
})();
